import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let ImageSetting = class ImageSetting extends Vue {
  constructor() {
    super(...arguments);
    this.imgUrl = "";
  }
  dataChage(value) {
    this.imgUrl = value.url;
    console.log(this.imgUrl, "图片预览组件---", value);
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], ImageSetting.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Object,
  default: {}
})], ImageSetting.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], ImageSetting.prototype, "dataChage", null);
ImageSetting = __decorate([Component({
  name: "imageSetting"
})], ImageSetting);
export default ImageSetting;